/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Breadcrumb } from "../../../parts";
import ApiError from "../../../components/Alert/ApiError";
import General from "./General";
import { isIndividual } from "../../../utils/utils";
import { useSelector } from "react-redux";
import { IRootState } from "../../../config/reducers";
import {
  PERMISSIONS,
  hasPermission,
  routeLoader,
  NetworkRequestErrorAlert,
} from "@advapacs/common";
import { PageNotFound } from "@src/components/PageNotFound";
import AdminSettingContainer from "./sideBar/AdminSettingContainer";
import { Footer } from "@src/parts";

const SecuritySetting = React.lazy(() =>
  routeLoader(() => import("./security/SecuritySetting"))
);

const AuthenticationContainer = React.lazy(() =>
  routeLoader(() => import("./authentication/AuthenticationContainer"))
);

const routes = [
  {
    show: isIndividual(),
    element: General,
    path: "/General",
    can: [PERMISSIONS.MANAGE_GENERAL_SETTING],
  },
  {
    show: false,
    element: SecuritySetting,
    path: "/Security",
    can: [PERMISSIONS.MANAGE_AUTHENTICATION],
  },
  {
    show: false,
    element: AuthenticationContainer,
    path: "/Authentication",
    can: [PERMISSIONS.MANAGE_AUTHENTICATION, PERMISSIONS.VIEW_AUTHENTICATION],
  },
];

const Setting: FC = () => {
  const { permissions } = useSelector(
    (state: IRootState) => state.loginReducer
  );
  return (
    <>
      <div className="content-wrapper">
        <Breadcrumb />
        <div className="content">
          <NetworkRequestErrorAlert />
          <ApiError />
          <AdminSettingContainer>
            <Routes>
              {routes
                .filter((x) => x.show || hasPermission(permissions, x.can))
                .map((f, index) => {
                  const Element = f.element;
                  return (
                    <Route key={index} path={f.path} element={<Element />} />
                  );
                })}

              <Route
                path="/"
                element={<Navigate to={"/Admin/Settings/General"} />}
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </AdminSettingContainer>
        </div>
        <Footer />
      </div>
    </>
  );
};
const SettingRoute = {
  path: "/Admin/Settings/*",
  component: <Setting />,
};

export default SettingRoute;
